import { createCrudSagas } from "./CrudSagas";
import { call, put } from "redux-saga/effects";
import { SmDefinitionsActions } from "../reducers/SmDefinitionsRedux";

const crudSagas = createCrudSagas("smDefinitions", SmDefinitionsActions);

export const findSmDefinitions = crudSagas.findSmDefinitions;
export const getSmDefinition = crudSagas.getSmDefinition;
export const createSmDefinition = crudSagas.createSmDefinition;
export const deleteSmDefinition = crudSagas.deleteSmDefinition;
export const watchSmDefinitions = crudSagas.watchSmDefinitions;
export const unwatchSmDefinitions = crudSagas.unwatchSmDefinitions;
//export const updateSmDefinition = crudSagas.updateSmDefinition;
export function* updateSmDefinition(api, { payload }) {
  try {
    const { smDefinition, valuePriorities, finalState } = payload;

    const response = yield call(
      api.patch,
      "smDefinitions",
      smDefinition._id,
      smDefinition
    );

    const stateVal = yield call(api.find, "stateDefinitions", {
      query: { smDefId: smDefinition._id },
    });

    const response2 = yield call(
      api.patch,
      "stateDefinitions",
      stateVal.data[0]._id,
      {
        valuePriorities,
        finalState,
      }
    );

    yield put(SmDefinitionsActions.updateSuccess(response));
  } catch (err) {
    console.error(err);
    yield put(SmDefinitionsActions.updateFailure(err.message));
  }
}
